import {Link} from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';

import LinkBox from "../LinkBox"

import "./Mosaics.css";
import "../Common.css"

function Mosaics()
{
    return (
        <div>
            <Container>
                <Row>
                    <Col xs={{ span: 12 }} className="topBuffer spacer-sm">
                        <img src="assets/Mosaics/Mosaic.png" className="center-block" alt="Mosaic"/>
                    </Col>
                    <LinkBox name="Lizard" href="Lizard" image="assets/Mosaics/Lizard.png" offset={1} />
                    <LinkBox name="Edge" href="Edge" image="assets/Mosaics/Edge.png" offset={0} />
                    <LinkBox name="Gallery" href="Gallery" image="assets/Mosaics/Gallery.png" offset={1} />
                    <LinkBox name="Continuous Celebrity" href="ContinuousCelebrity" image="assets/Mosaics/ContinuousCelebrity.png" offset={0} />
                    <LinkBox name="Lego Mosaic" href="https://main.d826oizkb4rn1.amplifyapp.com" image="assets/Mosaics/legoMosaic.png" offset={1} />
                </Row>
            </Container>
            <Link to="/Home" className="logo"></Link>
        </div>
      )
}

export default Mosaics;
